module.exports = __webpack_public_path__ + "static/media/spotme.415664b0.png";